module.exports = __webpack_public_path__ + "media/images/85/REM_sleep_night_stars-2ef449fbcea25d5a2210e3e3f6e1a7f3.webp";